/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2026
 */

/**
 * ArchetypeReportDiscountsComponent
 *
 * VIEW - Super Admin only
 *
 * Displays a table of all existing ArchetypeReportDiscounts
 * Provides the ability to create and delete archetype report discounts.
 */

import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';
import { catchError, of, take, tap } from 'rxjs';
import { ErrorHandlerService } from '../../../../services/error-handler.service';
import { SuccessService } from '../../../../services/success.service';
import { ArchetypeReportDiscountService, ArchetypeReportDiscount } from '../../resources/archetype-report-discount.service';
import { NewArchetypeReportDiscountModalComponent } from '../../components/modals/new-archetype-report-discount-modal/new-archetype-report-discount-modal.component';

@Component({
  selector: 'app-archetype-report-discounts',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './archetype-report-discounts.component.html',
})
export class ArchetypeReportDiscountsComponent implements OnInit {
  discounts: ArchetypeReportDiscount[] = [];

  constructor(
    private modalService: BsModalService,
    private errorHandlerService: ErrorHandlerService,
    private successService: SuccessService,
    private discountService: ArchetypeReportDiscountService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  /**
   * Load all discounts
   */
  load(): void {
    this.discountService
      .getAll()
      .pipe(
        tap((discounts) => {
          this.discounts = discounts;
          this.discounts.forEach((discount) => {
            if (!discount.discountType) {
              console.warn('Malformed discount: no discountType', discount);
              return;
            }
            switch (discount.discountType.identifier) {
              case 'flat_fee':
              case 'flat_discount':
                discount._discountAmountString =
                  '$' + (discount.discountAmountBps / 100).toFixed(2);
                break;
              case 'percentage':
                discount._discountAmountString =
                  (discount.discountAmountBps / 100).toFixed(2) + '%';
                break;
              default:
                discount._discountAmountString = 'UNKNOWN TYPE';
                console.warn('Unknown discountType identifier:', discount.discountType.identifier);
            }
          });
        }),
        catchError((error) => {
          this.errorHandlerService.handleError(error);
          return of(null);
        })
      )
      .subscribe();
  }

  /**
   * Open the create discount modal
   */
  openCreateDiscount(): void {
    const modalRef = this.modalService.show(NewArchetypeReportDiscountModalComponent);
    modalRef.onHidden?.pipe(take(1)).subscribe(() => {
      this.load();
    });
  }

  /**
   * Delete a discount
   */
  remove(discount: ArchetypeReportDiscount): void {
    if (!confirm(`Are you sure you want to delete discount code "${discount.name}"?`)) {
      return;
    }

    this.discountService
      .remove(discount._id)
      .pipe(
        tap(() => {
          this.successService.handle({
            message: 'Successfully deleted archetype report discount code.',
          });
          this.load();
        }),
        catchError((error) => {
          this.errorHandlerService.handleError(error);
          return of(null);
        })
      )
      .subscribe();
  }
}
